import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	displayNameField: {
		marginBottom: 20,
	},
	header: {
		color: brandPrimary,
		fontSize: 18,
		margin: '40px 0',
	},
	subHeader: {
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
	subjectFieldLabel: {
		display: 'block',
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
});
